import styles from "./styles.module.scss";
import CISA from "../../assets/aboutUs/CISA.png";
import CISSP from "../../assets/aboutUs/CISSP.png";
import AWSCertified from "../../assets/aboutUs/awsCertified.png";
import MicrosoftSecurity from "../../assets/aboutUs/Microsoft.png";
import SecurityAdministrator from "../../assets/aboutUs/SecurityAdministrator.png";

const Certifications = () => {
  return (
    <section
      className={styles.certifications}
      aria-labelledby="certifications-title"
    >
      <div className={styles.certificationsInner}>
        <header className={styles.certificationsHeading}>
          <p className={styles.eyebrow}>Practitioner credentials</p>
          <h2 id="certifications-title">Experience you can trust.</h2>
          <p>
            Training is grounded in recognized audit, security, cloud, and
            cybersecurity architecture disciplines.
          </p>
        </header>

        <ul className={styles.certificationGrid}>
          <li>
            <img
              className={styles.wideBadge}
              src={CISA}
              alt="CISA — Certified Information Systems Auditor"
              loading="lazy"
            />
          </li>
          <li>
            <img
              className={styles.wideBadge}
              src={CISSP}
              alt="CISSP — Certified Information Systems Security Professional"
              loading="lazy"
            />
          </li>
          <li>
            <img
              className={styles.squareBadge}
              src={AWSCertified}
              alt="AWS Certified Security — Specialty"
              loading="lazy"
            />
          </li>
          <li>
            <img
              className={styles.wideBadge}
              src={SecurityAdministrator}
              alt="Microsoft 365 Certified — Security Administrator Associate"
              loading="lazy"
            />
          </li>
          <li>
            <img
              className={styles.squareBadge}
              src={MicrosoftSecurity}
              alt="Microsoft Certified — Cybersecurity Architect Expert"
              loading="lazy"
            />
          </li>
        </ul>
      </div>
    </section>
  );
};

export default Certifications;
